
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[slug]",
      function () {
        return require("private-next-pages/team/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[slug]"])
      });
    }
  